import React from "react";
import { STYLE_DEFAULT_MASTER } from "App/constants";

import {
  IconButtonDatatable,
  InputCheckboxMaster,
  DatatablesFooter,
  TableHeader,
} from "App/Component/ui";

import {
  Table,
  TableContainer,
  TableCell,
  TableRow,
  TableBody,
} from "@material-ui/core";
import { getComparator, stableSort } from "App/Component/ui/datatable/utils";
import { useDatatables } from "App/hooks";
import { PencilIcon, SilangIcon, TrashIcon } from "App/Assets";

import {
  setVal,
  clickDelete,
  TableCellMenu,
  RenderArrow,
  headCells,
} from "./helpers";

const RenderAction = ({
  child,
  setFormData,
  showModal,
  setShowModal,
  showDeleteModal,
}) => {
  return (
    <>
      {child.is_function ? (
        ""
      ) : (
        <IconButtonDatatable
          onClick={() => {
            setFormData({
              id: "",
              code: "",
              is_function: 0,
              is_root: 0,
              name: "",
              icon: child.icon,

              parent_code: child.code,
              seq: "",
              status: 1,

              add_on_parent: 0,
              edit: 0,
              add_on_child: 1,

              is_root_parent: child.is_root,
              is_func_parent: child.is_function,
            });
            setShowModal(!showModal);
          }}>
          <SilangIcon
            style={{
              transform: "rotate(45deg)",
            }}
          />
        </IconButtonDatatable>
      )}

      <IconButtonDatatable
        onClick={() => {
          setVal(child, setFormData);
          setShowModal(!showModal);
        }}>
        <PencilIcon />
      </IconButtonDatatable>

      <IconButtonDatatable
        onClick={() => {
          showDeleteModal();
          clickDelete(child, setFormData);
        }}>
        <TrashIcon />
      </IconButtonDatatable>
    </>
  );
};

const handleClickArrow = (code) => {
  const allClass = document.getElementsByClassName(code);
  for (const item of allClass) {
    const ts = document.getElementById(item.id);
    const ch = ts.classList.contains("d-none");
    if (ch) {
      ts.classList.remove("d-none");
    } else {
      recursiveFindElement(item.id);
      ts.classList.add("d-none");
    }
  }
};

const recursiveFindElement = (code) => {
  const allClass = document.getElementsByClassName(code);
  if (allClass.length > 0) {
    for (const item of allClass) {
      const ts = document.getElementById(item.id);
      const ch = ts.classList.contains("d-none");
      if (!ch) {
        recursiveFindElement(item.id);
        ts.classList.add("d-none");
      }
    }
  }
};

const RecrusiveRow = ({
  rows,
  margin,
  formData,
  setFormData,
  setShowModal,
  setShowModalDeleteConfirm,
}) => {
  function showDeleteModal() {
    setShowModalDeleteConfirm(true);
  }

  return rows?.map((e, index) => {
    return (
      <>
        <tr className={`${e.parent_code} row d-none `} id={e.code} key={index}>
          <td></td>

          <td>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "7px",
              }}>
              <RenderAction
                child={e}
                formData={formData}
                setFormData={setFormData}
                setShowModal={setShowModal}
                showDeleteModal={() => showDeleteModal()}
              />
            </div>
          </td>
          <td onClick={() => handleClickArrow(e.code)}>
            <RenderArrow row={e} margin={margin} />
          </td>
          <td> {e.name} </td>
          <td align='left'>
            <InputCheckboxMaster
              checked={e?.is_root}
              readOnly={true}
              name='is_root'
              id='is_root'
              label=''
            />
          </td>

          <td align='left'>
            <InputCheckboxMaster
              checked={e?.is_function}
              name='is_func'
              id='is_func'
              readOnly={true}
              label=''
            />
          </td>
          <TableCellMenu row={e} />
        </tr>
        {e.sub.length > 0 && (
          <RecrusiveRow
            rows={e.sub}
            margin={margin + 20}
            formData={formData}
            setFormData={setFormData}
            setShowModal={setShowModal}
            setShowModalDeleteConfirm={setShowModalDeleteConfirm}
          />
        )}
      </>
    );
  });
};

const RenderContent = ({
  rows,
  formData,
  setFormData,
  setShowModal,
  setShowModalDeleteConfirm,
}) => {
  const classes = STYLE_DEFAULT_MASTER();

  const {
    page,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  function showDeleteModal() {
    setShowModalDeleteConfirm(true);
  }

  return (
    <>
      <TableContainer className='custom-scrollbar'>
        <Table
          className='custom-table'
          aria-labelledby='tableTitle'
          size={"medium"}
          aria-label='enhanced table'>
          <TableHeader
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <>
                    <tr key={index}>
                      <td align='center'> {++index} </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}>
                          <RenderAction
                            child={row}
                            formData={formData}
                            setFormData={setFormData}
                            setShowModal={setShowModal}
                            showDeleteModal={() => showDeleteModal()}
                          />
                        </div>
                      </td>
                      <td
                        onClick={() => handleClickArrow(row?.code)}
                        style={{
                          cursor: "pointer",
                        }}>
                        <RenderArrow row={row} margin={0} />
                      </td>
                      <td> {row?.name} </td>
                      <td align='left'>
                        <InputCheckboxMaster
                          checked={row?.is_root}
                          readOnly={true}
                          name='is_root'
                          id='is_root'
                          label=''
                        />
                      </td>

                      <td align='left'>
                        <InputCheckboxMaster
                          checked={row?.is_function}
                          name='is_func'
                          id='is_func'
                          readOnly={true}
                          label=''
                        />
                      </td>
                      <TableCellMenu row={row} />
                    </tr>
                    {row?.sub.length > 0 && (
                      <RecrusiveRow
                        rows={row?.sub}
                        margin={20}
                        formData={formData}
                        setFormData={setFormData}
                        setShowModal={setShowModal}
                        setShowModalDeleteConfirm={setShowModalDeleteConfirm}
                      />
                    )}
                  </>
                );
              })}
            {rows.length === 0 && (
              <TableRow>
                <TableCell align='center' colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  );
};

export default RenderContent;
